<template>
  <thead>
    <td :key="index" v-for="(field, index) in fields">
      <input
        :class="{ is_reverse: !is_plain_search, disable_th_search: !isEnabled(field) }"
        style="width: 100px;"
        @input="searchFilter(field, $event.target.value)"
        class="outlined search_filter"
        placeholder="Search"
      />
    </td>
  </thead>
</template>
<script>
export default {
  name: 'thead-searches',
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    is_plain_search: {
      type: Boolean,
      default: true
    },
    working_th_searches: {
      type: Array,
      default: () => undefined
    }
  },
  data () {
    return {
      searches: []
    }
  },
  created () {
    this.initSearches()
  },
  methods: {
    isEnabled (field) {
      if (this.working_th_searches == undefined) {
        return true
      }
      return this.working_th_searches.includes(field.name)
    },
    initSearches () {
      for (let i = 0; i < this.fields.length; i++) {
        let field = this.fields[i]
        if (field.type == 'operations') {
          continue
        }
        this.searches.push({
          name: field.name,
          path: field.value,
          term: ''
        })
      }
    },
    searchFilter (field, term) {
      this.searches = this.searches.map(search => {
        if (search.name == field.name) {
          search.term = term
        }
        return search
      })
      this.$emit('th_search', this.searches)
    }
  }
}
</script>
<style scoped>
  .disable_th_search{
    opacity: 0.2;
    pointer-events: none;
  }
  .is_reverse{
    background-color: rgba(0, 0, 0, 0.08);
  }
</style>
